<template>
  <div>
    <acheader></acheader>
    <div class="row mainbody">
      <div class="col-lg-2 col-md-4 col-sm-12">
        <poolsidebar></poolsidebar>
      </div>
      <div class="col-lg-10 col-md-8 col-sm-12">
        <div class="moduleWrapper">
          <div class="moduleCard">
            <div v-show="mode==='0'">
              <div class="row mb-3" v-show="tagList.length>0">
                <div class="col-12 text-right">
                  <div class="simdrop pull-right">
                    <button class="filterbtn btn btn-secondary btn-medium" @click="openCloseDropView" id="filter_by_tag">
                      Filter By Tag
                    </button>
                    <div class="simdropview" v-show="dropviewopen===true">
                      <div class="row">
                        <div class="col-12 text-center">
                          <button class="btn btn-secondary btn-short ib" @click="doCheckAllTags()" id="check_all">Check All</button>&nbsp;&nbsp;
                          <button class="btn btn-secondary btn-short ib" @click="doUncheckAllTags()" id="clear_all">Clear All</button>
                        </div>
                      </div>
                      <div class="taglist">
                        <p v-for="tag in tagList">
                          <input type="checkbox" class="checkbox" v-bind:checked="filterTags.indexOf(tag.LicensePoolTagID)>-1" @change="doFilterTags(tag.LicensePoolTagID)" /> {{tag.TagName}}
                        </p>
                      </div>
                      <button class="btn btn-primary" @click="openCloseDropView" id="done">Done</button>
                    </div>
                  </div>
                  <div class="clearfix"></div>
                </div>
              </div>
              <div v-if="wtdata!==null" class="wtOuter pl2">
                <wondertree :title="'Groups'" :thisdata="wtdata" :indentlevel="0" id="group_list" :burgermenu="burgermenu" :methods="wtmethods" :nomessage="'There are no groups'" ref="thiswt"
                            :isadmin="isadmin" :poolid="poolID"></wondertree>
              </div>
            </div>
            <div v-show="mode==='1'">
              <selectusers ref="selectUsersModule" :mode="'2'" :backbutton="true"></selectusers>
            </div>
            <div v-show="mode==='2'">
              <div class="mb-4 row">
                <div class="col-6">
                  <h1 id="new_message">New Message</h1>
                </div>
                <div class="col-6 text-right">
                  <a href="javascript:void(0)" @click="goBack"><font-awesome-icon icon="arrow-left" role="presentation"></font-awesome-icon><span id="go_back"> Go Back</span></a>
                </div>
              </div>
              <sendmessage ref="sMessage" v-if="selectedUsers!==null&&selectedUsers.length>0" :licensePoolID="poolID" :presetAddresses="selectedUsers" :allowForceEmail="true" :routeOnSend="rOnSend"></sendmessage>
              <div class="row mt-2" v-if="selectedUsers!==null&&selectedUsers.length===0">
                <div class="col-12">
                  This group does not contain any members to send a message to
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
    </div><acfooter></acfooter>
    <b-modal ref="addGroupModal" id="add_group" title="Add Group" @ok="completeAddGroup">
      <div class="row form">
        <div class="col-12">
          <label id="group_name">Group Name</label><br />
          <input type="text" v-model.trim="nGroupName" class="ifullWidth" />
        </div>
      </div>
      <div class="row form">
        <div class="col-12">
          <label id="group_parent">Group Parent</label><br />
          <select id="ddlGroupParent" type="text" v-model="nGroupParent" class="ifullWidth">
            <option v-for="group in flatgroups" v-bind:value="group.LicensePoolGroupID">
              {{group.LicensePoolGroupName}}
            </option>
          </select>
        </div>
      </div>
    </b-modal>
    <b-modal ref="massAddModal" size="lg" id="mass_add_group" title="Mass Add Groups" @ok="completeMassAddGroup">
      <div class="row form">
        <div class="col-12">
          <p id="instruction_mass_add_groups">
            Enter each group to add on one line below. To add subgroups: add a - (dash) directly in front of the group name. Use multiple dashes to represent further children.
            <br />
            <b>Example:</b><br>Campus A<br>-Department A<br>--Classroom A
          </p>

          <p>
            <textarea v-model.trim="nMassAdd" class="ifullWidth tta"></textarea>
          </p>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<style scoped>
  .filterbtn::after {
    display: inline-block;
    width: 0;
    height: 0;
    margin-left: .255em;
    vertical-align: .255em;
    content: "";
    border-top: .3em solid;
    border-right: .3em solid transparent;
    border-bottom: 0;
    border-left: .3em solid transparent;
  }

  .simdrop {
    position: relative;
    width: 250px;
  }

  .simdropview {
    position: fixed;
    top: 200px;
    border: 1px solid #333;
    border-radius: 5px;
    width: 400px;
    right: 34px;
    background: #FFF;
    z-index: 5;
    height: 600px;
    text-align: left;
    padding: 1%;
  }

  .taglist {
    overflow-y: scroll;
    height: 450px;
  }

  .tta {
    height: 200px;
  }

</style>

<script>
  import acheader from "../../layout/Header.vue"
  import acfooter from "../../layout/Footer.vue"
  import poolsidebar from "../../layout/Pool/Sidebar.vue"
  import selectusers from "../../components/SelectUsers.vue"
  import sendmessage from "../../components/SendMessage.vue"


  var PortalID = "";
  var portalURL = "";
  var UMichPoolID = "";
  if (window.location.origin.indexOf("admin.simmersion.com") > -1) {
    PortalID = "7728DEAD-2980-4748-9213-D49B97B74AE8";
    portalURL = "https://tcapi.simmersion.net";
    UMichPoolID = "E0CE9164-5DE4-487E-A5FA-32777755FA31";
  }
  else {
    PortalID = "7728DEAD-2980-4748-9213-D49B97B74AE8";
    portalURL = "https://tcapi.simmersionstage.net";
    UMichPoolID = "E0CE9164-5DE4-487E-A5FA-32777755FA31";
  }

  export default {
    name: 'PoolGroups',
    components: { acheader, acfooter, poolsidebar, selectusers, sendmessage },
    data() {
      return {
        burgermenu: [],
        dropviewopen: false,
        filterTags: [],
        groups: [],
        isadmin: false,
        isAssignFlow: null,
        mode: '0',
        nGroupName: "",
        nGroupParent: null,
        nMassAdd: "",
        rOnSend: null,
        poolID: null,
        selectedUsers: [],
        tagList: [],
        wtdata: null,
        search: "",
        wtmethods: {
          add: {
            method: function (param, ref) {
              ref.doAdd(param);
            },
            ref: this
          },
          assignProducts: {
            method: function (param, ref) {
              ref.assignProducts(param);
            },
            ref: this
          },
          assignTrainingPlans: {
            method: function (param, ref) {
              ref.assignTrainingPlans(param);
            },
            ref: this
          },
          assignBundles: {
            method: function (param, ref) {
              ref.assignBundles(param);
            },
            ref: this
          },
          massAdd: {
            method: function (param, ref) {
              ref.doMassAdd(param);
            },
            ref: this
          },
          createTags: {
            method: function (param, ref) {
              ref.doCreateTags(param);
            },
            ref: this
          },
          sendMessage: {
            method: function (param, ref) {
              ref.doSendMessage(param);
            },
            ref: this
          },
          RefreshData: {
            method: function (param, ref) {
              ref.RefreshData(param);
            },
            ref: this
          }
        }
      }
    },
    methods: {
      filteredList() {
        return this.groups.filter((group) =>
          group.nGroupName.toLowerCase().includes(this.search)
        );

      },
      addMassGroupSub(nGroupName, parentID, children, level) {
        this.apiCommand([
          {
            Operation: "LicensePool",
            Function: "AddGroup",
            Fields: {
              LicensePoolGroupName: nGroupName,
              LicensePoolID: this.$route.params.id,
              ParentID: parentID
            }
          }
        ]).then(r => {


          var cr = JSON.parse(r.CommandResult);
          if (cr.returnObjects[0].returnObject.length === 36 && children.length > 0) {

            var grt = [];
            for (var q = 0; q < children.length; q++) {

              if (children[q].match(/\-/g).length === level) {
                var c = {
                  Name: children[q].replace(/-/g, "").trim(),
                  Children: []
                };

                for (var y = q + 1; y < children.length; y++) {
                  c.Children.push(children[y].trim());
                }

                grt.push(c);
              }
            }

            for (var x = 0; x < grt.length; x++) {
              this.addMassGroupSub(grt[x].Name, cr.returnObjects[0].returnObject, grt[x].Children, level + 1);
            }
          }
        });
      },
      assignBundles(param) {
        this.isAssignFlow = "bundles";
        this.mode = '1';
        var self = this;
        window.setTimeout(function () {
          self.$refs["selectUsersModule"].setData("Select Groups To Assign Bundles", [], null, [], self.groups);
        }, 200);
      },
      assignTrainingPlans(param) {
        this.isAssignFlow = "trainingplans";
        this.mode = '1';
        var self = this;
        window.setTimeout(function () {
          self.$refs["selectUsersModule"].setData("Select Groups To Assign Training Plans", [], null, [], self.groups);
        }, 200);
      },
      assignProducts(param) {
        this.isAssignFlow = "products";
        this.mode = '1';
        var self = this;
        window.setTimeout(function () {
          self.$refs["selectUsersModule"].setData("Select Groups To Assign Products", [], null, [], self.groups);
        }, 200);
      },
      doCheckAllTags() {
        for (var t of this.tagList) {
          if (this.filterTags.indexOf(t.LicensePoolTagID) === -1) {
            this.filterTags.push(t.LicensePoolTagID);
          }
        }
        this.compileGroupList();
      },
      doCreateTags() {
        this.$router.push("/pool/" + this.$route.params.id + "/tags");
      },
      doUncheckAllTags() {
        this.filterTags = [];
        this.compileGroupList();
      },
      compileGroupList() {
        var groupList = [];
        for (var group of this.groups) {

          if (this.filterTags.length > 0) {
            if (group.Tags.filter(p => this.filterTags.indexOf(p.LicensePoolTagID) > -1).length > 0) {
              groupList.push(group);
            }
          }
          else {
            groupList.push(group);
          }
        }
        this.flatgroups = groupList;
        this.flatgroups.unshift({
          LicensePoolGroupID: this.emptyguid,
          LicensePoolGroupName: "--- Parent ---"
        });
        this.nGroupParent = this.emptyguid;

        this.wtdata = this.buildGroupHierarchy(this.emptyguid, groupList, this.sdata.activepool.IsAdmin, true);
        setTimeout(Window.loadLanguageContent(), 5000);
      },
      completeAddGroup(bvModalEvt) {
        if (this.nGroupName.length > 0) {
          this.apiCommand([
            {
              Operation: "LicensePool",
              Function: "AddGroup",
              Fields: {
                LicensePoolGroupName: this.nGroupName,
                LicensePoolID: this.$route.params.id,
                ParentID: this.nGroupParent
              }
            }
          ]).then(r => {

            var cr = JSON.parse(r.CommandResult);
            if (cr.returnObjects[0].returnObject.length === 36) {
              this.doPage(true).then(r => {
                this.bootstrapPool(this.$route.params.id);
                this.popDialog(0, "Group added successfully");
                this.renderTree();
                this.$refs["thiswt"].update();
              });
            }
            else {
              this.popDialog(1, cr.returnObjects[0].returnObject);
            }

          });
        }
        else {
          this.popDialog(1, "Group name is required");
        }
      },
      completeMassAddGroup() {
        if (this.nMassAdd.length > 0) {

          var grps = this.nMassAdd.split('\n');
          var grt = [];

          for (var x = 0; x < grps.length; x++) {

            var grpname = grps[x].trim();
            if (grpname[0] !== "-") {
              var c = {
                Name: grpname.replace("-", "").trim(),
                Children: []
              };

              for (var y = x + 1; y < grps.length; y++) {
                if (grps[y].trim()[0] === "-") {
                  c.Children.push(grps[y].trim());
                }
                else {
                  break;
                }
              }

              grt.push(c);
            }
          }

          for (var x = 0; x < grt.length; x++) {
            this.addMassGroupSub(grt[x].Name, "00000000-0000-0000-0000-000000000000", grt[x].Children, 1);
          }

          this.popDialog(0, "Operation successful, please wait a few seconds for refresh");

          var self = this;
          window.setTimeout(function () {
            this.doPage(true).then(r => {
              this.bootstrapPool(this.$route.params.id);
              self.renderTree();
              this.$refs["thiswt"].update();
            });
          }, 2000);

        }
        else {
          this.popDialog(1, "Group names are required");
        }
      },
      doAdd() {
        this.$refs["addGroupModal"].show();
        Window.loadLanguageContent();
      },
      doMassAdd() {
        this.$refs["massAddModal"].show();
        Window.loadLanguageContent();
      },
      doCreateTags() {
        this.$router.push("/pool/" + this.$route.params.id + "/tags");
        Window.loadLanguageContent();
      },
      doFilterTags(tagID) {
        var i = this.filterTags.indexOf(tagID);
        if (i > -1) {
          this.filterTags.splice(i, 1);
        }
        else {
          this.filterTags.push(tagID);
        }
        this.compileGroupList();
        Window.loadLanguageContent();
      },
      doSendMessage() {
        this.$refs["selectUsersModule"].setData("Select Groups to Message/Email", [], null, [], this.groups);
        this.mode = '1';
        Window.loadLanguageContent();
      },
      goBack() {
        this.selectedUsers = [];
        this.mode = '0';
      },
      isDisabled() {
        let flag = false;
        if (sessionStorage.getItem("isSimmersionUser")) {
          var sdata = localStorage.getItem("sdata");
          if (sdata != null) {
            var all_pools = JSON.parse(sdata).allpools;
            var all_groups = JSON.parse(sdata).allgroups;
            if (all_pools.length > 0) {
              for (var i = 0; i < all_pools.length; i++) {
                if (all_pools[i].LicensePoolID == '91961f0a-b004-43a6-967d-32b36ddd66b0') {
                  flag = true;
                  break;
                }
              }
            }

            if (all_groups.length > 0 && flag == false) {
              for (var i = 0; i < all_groups.length; i++) {
                if (all_groups[i].LicensePoolID == '91961f0a-b004-43a6-967d-32b36ddd66b0') {
                  flag = true;
                  break;
                }
              }
            }
          }
        }
        return flag;
      },
      groupsSelected() {
        var cmds = [];
        for (var group of this.$refs["selectUsersModule"].selectedGroups) {
          cmds.push({
            Operation: "LicensePool",
            Function: "GetGroupUsers",
            Fields: {
              LicensePoolID: this.$route.params.id,
              GroupID: group.value
            }
          })
        }

        this.apiCommand(cmds).then(r => {
          this.selectedUsers = [];
          var cr = JSON.parse(r.CommandResult);
          for (var x = 0; x < cr.returnObjects.length; x++) {
            for (var gu of JSON.parse(cr.returnObjects[x].returnObject)) {
              if (this.selectedUsers.filter(p => p.ClientID === gu.ClientID).length === 0) {
                this.selectedUsers.push({
                  Name: this.buildSimUser(gu.ClientID, gu.Username, gu.EmailAddress, gu.FirstName, gu.LastName, false, false),
                  ClientID: gu.ClientID
                });
              }
            }
          }
          if (this.isAssignFlow === null) {
            this.mode = '2';
          }
          else {
            localStorage.setItem("assigndata", JSON.stringify(this.selectedUsers));
            this.$router.push("/pool/" + this.$route.params.id + "/assign/" + this.isAssignFlow + "/do");
          }
        });
      },
      openCloseDropView() {
        if (this.dropviewopen) {
          this.dropviewopen = false;
        }
        else {
          this.dropviewopen = true;
        }
      },
      RefreshData(param) {

        this.responseAvailable = false;

        fetch(portalURL + "/SSO.svc/RunCronScriptForGroup", {
          "method": "GET"
        })
          .then(response => {
            if (response.ok) {
              return response.json()
            } else {
              this.popDialog(1, "Server returned " + response.status + " : " + response.statusText);
            }
          })
          .then(response => {
            if (response.status == "started") {
              this.popDialog(0, "Group List Refresh started; it takes 10 minutes to complete.");
            } else if (response.status == "running") {
              this.popDialog(2, "Group List Refresh is already running; please try refreshing your list in 20 minutes.");
            } else if (response.status == "error") {
              this.popDialog(1, "Error occured while executing SSO Group Refresh script.");
            }
            this.responseAvailable = true;
            this.renderTree();
          })
          .catch(err => {
            this.popDialog(1, err);
          });
      },
      renderTree() {
        this.apiCommand([
          {
            Operation: "LicensePool",
            Function: "GetGroupsWithTag",
            Fields: {
              LicensePoolID: this.$route.params.id
            }
          },
          {
            Operation: "LicensePool",
            Function: "GetTags",
            Fields: {
              LicensePoolID: this.$route.params.id
            }
          }
        ]).then(response => {

          var cr = JSON.parse(response.CommandResult);
          this.groups = JSON.parse(cr.returnObjects[0].returnObject);
          this.tagList = JSON.parse(cr.returnObjects[1].returnObject);

          if (this.sdata.activepool.IsAdmin) {
            if (this.isDisabled()) {
              this.burgermenu = [
                [
                  { html: "Refresh Group List", value: "RefreshData", class: "btn-secondary" }
                ],
                [
                  { html: "Options", value: null },
                  { html: "Add Group", value: "add" },
                  { html: "Mass Add Groups&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;", value: "massAdd" },
                  { html: "Edit Tags", value: "createTags" }
                ]
                //,[
                //  { html: "Assign (+)", value: null },
                //  { html: "Assign Products", value: "assignProducts" },
                //  { html: "Assign Bundles", value: "assignBundles" },
                //  { html: "Assign Training Plans&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;", value: "assignTrainingPlans" }
                //]

              ];
            }
            else {
              this.burgermenu = [
                [
                  { html: "Options", value: null },
                  { html: "Add Group", value: "add" },
                  { html: "Mass Add Groups&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;", value: "massAdd" },
                  { html: "Edit Tags", value: "createTags" },
                  { html: "Send Message", value: "sendMessage" }
                ],
                [
                  { html: "Assign (+)", value: null },
                  { html: "Assign Products", value: "assignProducts" },
                  { html: "Assign Bundles", value: "assignBundles" },
                  { html: "Assign Training Plans&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;", value: "assignTrainingPlans" }
                ]
              ];
            }

          }

          this.compileGroupList();
          Window.loadLanguageContent();

        });
      }
    },
    mounted() {
      this.doPage().then(r => {
        this.bootstrapPool(this.$route.params.id);
        this.isadmin = this.sdata.activepool.IsAdmin;

        this.poolID = this.$route.params.id;
        this.rOnSend = "/pool/" + this.$route.params.id + "/groups";
        this.renderTree();
        setTimeout("Window.loadLanguageContent()", 500);
      });
      if (sessionStorage.getItem("isSimmersionUser")) {
        this.popDialog(2, "Account management is handled at the organization level. To make account related changes, please log into the Lifeline Learning Portal and visit the Users page.");
      }
    }
  }
</script>
